import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SetbackMark } from "../components/SetbackMark";
import { normalizeUsername, saveStoredUsername } from "../lib/username";
import { saveUsernameProfile } from "../hooks/useAuth";

export default function SignInPage() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleContinue() {
    const nextName = normalizeUsername(name);
    if (!nextName) {
      setError("Please enter a username.");
      return;
    }

    setError(null);
    setBusy(true);
    try {
      const savedName = saveStoredUsername(nextName);
      await saveUsernameProfile(savedName);
      navigate("/", { replace: true });
    } catch (e: any) {
      setError(e.message ?? "Couldn't save your username.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-10">
      <div className="w-full max-w-md rounded-3xl border border-white/15 bg-gradient-to-b from-white/10 to-white/5 p-8 shadow-2xl backdrop-blur-xl">
        <div className="mb-6 flex items-center gap-3">
          <SetbackMark className="h-12 w-12 shrink-0" />
          <h1 className="text-4xl font-bold tracking-tight">Setback</h1>
        </div>
        <p className="mb-2 text-2xl font-semibold">What should we call you?</p>
        <p className="mb-6 text-sm text-white/65">Pick the name everyone will see in lobbies and at the table.</p>

        <input
          value={name}
          onChange={e => setName(e.target.value)}
          maxLength={20}
          placeholder="Enter a username"
          className="mb-4 w-full rounded-xl border border-white/20 bg-black/25 px-4 py-3 text-white outline-none transition focus:border-emerald-300 focus:ring-2 focus:ring-emerald-300/40"
          onKeyDown={e => {
            if (e.key === "Enter") void handleContinue();
          }}
        />

        <button
          onClick={handleContinue}
          disabled={busy}
          className="w-full rounded-xl bg-emerald-500 py-3 font-semibold text-slate-900 transition hover:bg-emerald-400 disabled:opacity-50"
        >
          {busy ? "Starting…" : "Let's Play"}
        </button>
        {error && <div className="mt-3 text-sm text-red-300">{error}</div>}
      </div>
    </div>
  );
}
